import parse from 'url-parse';
import CONSTANTS from '../constants';

export default {
  setQrCode,
  getQrCode,
  getRawQrCode,
  removeQrCode,
  getTable,
  getQrCodeByLocation
};

function setQrCode(qrUrl) {
  let parsedUrl = parse(qrUrl, true);
  if (
    parsedUrl &&
    parsedUrl.query &&
    parsedUrl.query.loc_id &&
    parsedUrl.query.table_id &&
    parsedUrl.query.uniqid
  ) {
    localStorage.setItem(`${CONSTANTS.CACHE_KEY_PREFIX}_qrCode`, qrUrl);
    return parsedUrl.query;
  }
}

function getQrCode() {
  let qrUrl = localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_qrCode`);
  if (qrUrl) {
    let parsedUrl = parse(qrUrl, true);
    return parsedUrl.query;
  }
}

function getRawQrCode() {
  return localStorage.getItem(`${CONSTANTS.CACHE_KEY_PREFIX}_qrCode`);
}

async function getTable(loc_id, table_id) {
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.LOCATIONS.TABLES(loc_id, table_id)}`;
  let table = await fetch(url, {
    method: 'GET',
    headers: { ...CONSTANTS.REQUEST_HEADERS }
  });
  table = await table.json();
  if (table) return table;

  throw new Error('Could not fetch table');
}

async function getQrCodeByLocation(loc_id, unique_id) {
  let url = `${CONSTANTS.NODE_API_URL}${CONSTANTS.URLS.LOCATIONS.QRCODE(loc_id, unique_id)}`;
  let table = await fetch(url, {
    method: 'GET',
    headers: { ...CONSTANTS.REQUEST_HEADERS }
  });
  table = await table.json();
  if (table) return table;

  throw new Error('Could not fetch table');
}

function removeQrCode() {
  localStorage.removeItem(`${CONSTANTS.CACHE_KEY_PREFIX}_qrCode`);
}
